import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Matomo‑Tracking‑Hook (Classic)
 *
 * @param trackerUrl   Basis‑URL zu deiner Matomo‑Instanz (ohne trailing slash)
 */
export const useMatomo = (trackerUrl: string) => {
    const location = useLocation();
    const siteId = 8;
    // -----------------------------------------------------------------
    // Skript‑Einbindung
    // -----------------------------------------------------------------
    useEffect(() => {
        //  → kein Tracking im lokalen Development oder in Nicht‑Prod‑Umgebungen
        if (
            window.location.hostname === "localhost" ||
            process.env.NODE_ENV !== "production"
        )
            return;

        // ---- 1.1. Tracker‑Array anlegen und konfigurieren -----------------
        const _paq = (window._paq = window._paq || []);

        // Konfiguration **vor** dem Laden von matomo.js
        _paq.push(["setTrackerUrl", `${trackerUrl}/matomo.php`]);
        _paq.push(["setSiteId", siteId.toString()]);
        _paq.push(["enableLinkTracking"]); // optional – aktiviert automatisches Link‑Tracking
        _paq.push(["trackPageView"]); // erster Hit (Landing‑Page)

        // ---- 1.2. Skript‑Tag erzeugen ------------------------------------
        const d = document;
        const g = d.createElement("script");
        const s = d.getElementsByTagName("script")[0];

        g.async = true;
        g.src = `${trackerUrl}/matomo.js`;

        // Optional: Fehler‑Reporting, damit du erkennst, ob das Script geladen wurde
        g.onerror = () => {
            console.error("[Matomo] matomo.js konnte nicht geladen werden – prüfen Sie URL/SSL.");
        };

        // Insert before the first <script> tag
        s.parentNode?.insertBefore(g, s);
    }, [trackerUrl, siteId]);

    // -----------------------------------------------------------------
    // Aktualisieren des Trackers
    // -----------------------------------------------------------------
    useEffect(() => {
        const _paq = window._paq || [];
        _paq.push(["setCustomUrl", window.location.href]);
        _paq.push(["trackPageView"]);
    }, [location]);
};